import type { useAdminColors } from '@/hooks/admin/useAdminColors';

type AdminColors = ReturnType<typeof useAdminColors>;
type ThemeMode = AdminColors['mode'];

export function hexToRgba(hex: string, alpha: number): string {
  const cleaned = hex.replace('#', '');
  const r = parseInt(cleaned.substring(0, 2), 16);
  const g = parseInt(cleaned.substring(2, 4), 16);
  const b = parseInt(cleaned.substring(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return `rgba(107, 114, 128, ${alpha})`;
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export interface TagPillColorSlots {
  bg: string;
  border: string;
  text: string;
  iconOpacity: number;
}

export function tagPillColors(
  hex: string | null,
  disabled: boolean,
  mode: ThemeMode,
  redesign: AdminColors['redesign'],
): TagPillColorSlots {
  if (disabled || !hex) {
    return {
      bg: redesign.glass.buttonBg,
      border: redesign.card.border,
      text: redesign.text.subtle,
      iconOpacity: disabled ? 0.5 : 1,
    };
  }

  const bgAlpha = mode === 'light' ? 0.18 : 0.15;
  const borderAlpha = mode === 'light' ? 0.55 : 0.4;

  return {
    bg: hexToRgba(hex, bgAlpha),
    border: hexToRgba(hex, borderAlpha),
    text: hex,
    iconOpacity: 1,
  };
}
